import { render, staticRenderFns } from "./comparison.vue?vue&type=template&id=46961fc6&"
import script from "./comparison.vue?vue&type=script&lang=js&"
export * from "./comparison.vue?vue&type=script&lang=js&"
import style0 from "./comparison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46961fc6')) {
      api.createRecord('46961fc6', component.options)
    } else {
      api.reload('46961fc6', component.options)
    }
    module.hot.accept("./comparison.vue?vue&type=template&id=46961fc6&", function () {
      api.rerender('46961fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/componetsPage/comparison.vue"
export default component.exports